<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col sm="7">
            <h4 id="traffic" class="card-title mb-0">Mis Notificaciones</h4>
            <div class="small text-muted">Historial completo de notificaciones recibidas</div>
          </b-col>
          <b-col sm="5" class="d-flex justify-content-end align-items-start notifications-inbox-header-actions">
            <b-button type="button" variant="outline-dark" size="sm" class="btn-pill" @click="filtersVisible = !filtersVisible" v-b-tooltip.hover :title="filtersVisible ? 'Ocultar filtros' : 'Mostrar filtros'">
              <b-icon icon="filter" class="mr-1"></b-icon> Filtros
            </b-button>
            <b-button type="button" variant="outline-dark" size="sm" class="btn-pill" @click="markAllRead()" v-if="hasUnread">
              <i class="fa fa-check-double"></i> Marcar todas como leídas
            </b-button>
            <b-button type="button" variant="outline-secondary" size="sm" class="btn-pill" @click="archiveAll()" v-if="hasArchivable">
              <b-icon icon="archive" class="mr-1"></b-icon> Archivar todas
            </b-button>
          </b-col>
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-collapse v-model="filtersVisible">
          <b-row>
            <b-col sm="4" class="mb-2 mb-sm-0">
              <b-form-group description="Buscá por título o mensaje" class="mb-0">
                <b-form-input type="text" size="sm" placeholder="Ingrese su búsqueda" v-model="filter.search"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="4" class="mb-2 mb-sm-0">
              <b-row>
                <b-col cols="6" class="pr-1">
                  <b-form-input type="date" v-model="filter.date_start" placeholder="Desde"></b-form-input>
                </b-col>
                <b-col cols="6" class="pl-1">
                  <b-form-input type="date" v-model="filter.date_end" placeholder="Hasta"></b-form-input>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="2" class="mb-2 mb-sm-0">
              <b-form-select v-model="filter.status" :options="arr.select.status"></b-form-select>
            </b-col>
            <b-col sm="2">
              <b-button variant="outline-dark" block @click="search()">
                <b-icon icon="filter" class="mr-1" style="font-size:15px;"></b-icon>
                Filtrar
              </b-button>
            </b-col>
          </b-row>
        </b-collapse>

        <b-row class="mt-3">
          <b-col>
            <b-table class="mb-0"
                  responsive="sm"
                  head-variant="dark"
                  :hover="true"
                  :small="true"
                  :items="table.items"
                  :fields="table.fields"
                  :current-page="table.currentPage"
                  :per-page="table.perPage"
                  :tbody-tr-class="rowClass"
                  v-if="table.items.length">

              <template v-slot:cell(read)="data">
                <b-badge variant="dark" v-if="data.item.archived">
                  <b-icon icon="archive-fill" class="mr-1"></b-icon>Archivada
                </b-badge>
                <b-badge variant="success" v-else-if="data.item.read">
                  <b-icon icon="check-circle-fill" class="mr-1"></b-icon>Leída
                </b-badge>
                <b-badge variant="warning" v-else>
                  <b-icon icon="exclamation-circle-fill" class="mr-1"></b-icon>Sin leer
                </b-badge>
              </template>

              <template v-slot:cell(created_at)="data">
                {{ formatDate(data.item.created_at) }}
              </template>

              <template v-slot:cell(title)="data">
                <div class="d-flex align-items-center notifications-inbox-row-clickable" @click="openDetail(data.item)">
                  <b-avatar size="2rem" :src="data.item.icon" icon="bell-fill" :variant="avatarVariant(data.item)" class="mr-2"></b-avatar>
                  <div class="notifications-inbox-title-col">
                    <strong :class="{ 'text-muted': data.item.archived }">{{ data.item.title }}</strong>
                    <div class="small text-muted notifications-inbox-preview" v-if="data.item.message">{{ data.item.message }}</div>
                  </div>
                </div>
              </template>

              <template v-slot:cell(module)="data">
                <b-badge variant="info" v-if="data.item.module">
                  {{ data.item.module.title || data.item.module.name }}
                </b-badge>
                <span class="small text-muted" v-else>Sistema</span>
              </template>

              <template v-slot:cell(actions)="data">
                <div class="d-flex justify-content-center">
                  <b-dropdown size="sm"
                              variant="outline-dark"
                              toggle-class="notifications-inbox-actions-toggle"
                              right
                              no-caret>
                    <template v-slot:button-content>
                      <b-icon icon="three-dots-vertical"></b-icon>
                    </template>

                    <b-dropdown-item v-if="data.item.url" @click="openItem(data.item)">
                      <b-icon icon="box-arrow-up-right" class="mr-2"></b-icon>Abrir enlace
                    </b-dropdown-item>
                    <b-dropdown-item v-if="!data.item.read" @click="markReadItem(data.item)">
                      <b-icon icon="check2" class="mr-2"></b-icon>Marcar como leída
                    </b-dropdown-item>
                    <b-dropdown-item v-if="!data.item.archived" @click="archiveItem(data.item)">
                      <b-icon icon="archive" class="mr-2"></b-icon>Archivar
                    </b-dropdown-item>
                    <b-dropdown-item v-if="data.item.archived" @click="restoreItem(data.item)">
                      <b-icon icon="arrow-counterclockwise" class="mr-2"></b-icon>Restaurar
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </template>

            </b-table>
            <b-alert v-else variant="warning" show>No se encontraron notificaciones</b-alert>
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <i class="fa fa-angle-double-left"></i>
              Volver
            </b-button>
          </b-col>

          <b-col>
            <nav>
              <b-pagination class="pull-right mb-0"
                            size="sm"
                            pills=""
                            :total-rows="table.items.length"
                            :per-page="table.perPage"
                            v-model="table.currentPage" />
            </nav>
          </b-col>
        </b-row>
      </b-card>

      <b-modal v-model="modal.detail" :title="modal.item ? modal.item.title : ''" hide-footer centered scrollable>
        <template v-if="modal.item">
          <div class="d-flex align-items-center flex-wrap notifications-inbox-modal-meta mb-3">
            <b-badge variant="info" v-if="modal.item.module" class="mr-2">
              {{ modal.item.module.title || modal.item.module.name }}
            </b-badge>
            <span class="small text-muted mr-2" v-else>Sistema</span>
            <span class="small text-muted">{{ formatDate(modal.item.created_at) }}</span>
          </div>
          <div class="notifications-inbox-modal-body">{{ modal.item.message || 'Sin detalle adicional' }}</div>
        </template>
        <template v-slot:modal-footer>
          <b-button size="sm" variant="outline-dark" @click="modal.detail = false">Cerrar</b-button>
          <b-button size="sm" variant="primary" v-if="modal.item && modal.item.url" @click="openUrl(modal.item.url); modal.detail = false">
            <b-icon icon="box-arrow-up-right" class="mr-1"></b-icon>Abrir enlace
          </b-button>
        </template>
      </b-modal>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import moment from 'moment'

  export default {
    data: () => {
      return {
        access: {
          module_id: Modules.NOTIFICACIONES,
          profile_id: Profiles.PERSONAL,
          view_reference: 'inbox',
          elements: {}
        },
        table: {
          items: [],
          fields: [
            {key: 'title', label: 'Notificación', class: "align-middle"},
            {key: 'module', label: 'Origen', class: "align-middle text-left"},
            {key: 'created_at', label: 'Fecha', class: "align-middle text-left"},
            {key: 'read', label: 'Estado', class: "align-middle text-center"},
            {key: 'actions', label: '', class: "align-middle text-center"},
          ],
          currentPage: 1,
          perPage: 20,
        },
        arr: {
          select: {
            status: [
              { value: '', text: 'TODAS' },
              { value: 'unread', text: 'SIN LEER' },
              { value: 'read', text: 'LEÍDAS' },
              { value: 'archived', text: 'ARCHIVADAS' },
            ],
          }
        },
        filter: {
          search: '',
          date_start: '',
          date_end: '',
          status: '',
        },
        // Ocultos por default en mobile (ocupaban toda la pantalla antes de
        // llegar a ver una sola notificación); visibles por default en
        // desktop, donde entran en una sola fila y no molestan.
        filtersVisible: window.innerWidth >= 576,
        modal: {
          detail: false,
          item: null,
        },
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },
    mounted() {
      this.search()

      this._start = true
    },
    activated() {
      if (this._start) {
        this._start = false
        return
      }

      this.search()
    },
    computed: {
      hasUnread() {
        if (this.filter.status == 'archived') return false
        return this.table.items.some(item => !item.read && !item.archived)
      },
      hasArchivable() {
        if (this.filter.status == 'archived') return false
        return this.table.items.some(item => !item.archived)
      }
    },
    methods: {
      search() {
        let loader = this.$loading.show()

        var result = serviceAPI.listInternal(this.filter)
        result.then((response) => {
          loader.hide()
          this.table.items = response.data
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        })
      },
      // Ver el detalle completo (texto largo, ej. el tail del log de un error
      // de instancias) en un modal en vez del preview recortado de la fila —
      // ilegible en la tabla y menos todavía en mobile.
      openDetail(item) {
        this.modal.item = item
        this.modal.detail = true

        if (!item.read) {
          serviceAPI.markInternalRead(item.id).then(() => { item.read = true })
        }
      },
      openItem(item) {
        if (!item.read) {
          serviceAPI.markInternalRead(item.id)
            .then(() => {
              item.read = true
              if (item.url) this.openUrl(item.url)
            })
        } else if (item.url) {
          this.openUrl(item.url)
        }
      },
      // Link interno del sistema: navega en la misma pestaña. Link externo
      // (otro dominio): se abre en una pestaña nueva para no perder el contexto actual.
      openUrl(url) {
        let isExternal = false
        try {
          isExternal = new URL(url, window.location.origin).hostname !== window.location.hostname
        } catch (e) {
          isExternal = false
        }

        if (isExternal) {
          window.open(url, '_blank')
        } else {
          window.location.href = url
        }
      },
      markReadItem(item) {
        serviceAPI.markInternalRead(item.id)
          .then(() => {
            item.read = true
          })
      },
      markAllRead() {
        serviceAPI.markAllInternalRead()
          .then(() => {
            this.table.items.forEach(item => { item.read = true })
            this.$awn.success("Notificaciones marcadas como leídas")
          })
      },
      archiveItem(item) {
        serviceAPI.archiveInternal(item.id)
          .then(() => {
            this.$awn.success("Notificación archivada")
            this.search()
          })
          .catch(error => {
            this.$awn.alert(Error.showError(error))
          })
      },
      restoreItem(item) {
        serviceAPI.restoreInternal(item.id)
          .then(() => {
            this.$awn.success("Notificación restaurada")
            this.search()
          })
          .catch(error => {
            this.$awn.alert(Error.showError(error))
          })
      },
      archiveAll() {
        this.$bvModal.msgBoxConfirm('¿Archivar todas las notificaciones?', {
          title: 'Archivar todas',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'dark',
          okTitle: 'ARCHIVAR',
          cancelVariant: 'outline-dark',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerBgVariant: 'dark',
          headerTextVariant: 'black',
          hideHeaderClose: false,
          centered: false
        })
        .then(value => {
          if (value) {
            serviceAPI.archiveAllInternal()
              .then(() => {
                this.$awn.success("Notificaciones archivadas")
                this.search()
              })
              .catch(error => {
                this.$awn.alert(Error.showError(error))
              })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        })
      },
      avatarVariant(item) {
        if (item.archived) return 'secondary'
        if (!item.read) return 'warning'
        return 'dark'
      },
      rowClass(item) {
        if (!item) return ''
        if (item.archived) return 'notifications-inbox-row-archived'
        if (!item.read) return 'notifications-inbox-row-unread'
        return ''
      },
      formatDate(date) {
        return moment(date).format('DD/MM/YYYY HH:mm')
      },
    }
  }
</script>
<style scoped>
  .notifications-inbox-header-actions {
    gap: 8px;
  }
  .notifications-inbox-row-clickable {
    cursor: pointer;
  }
  .notifications-inbox-title-col {
    min-width: 0;
  }
  .notifications-inbox-preview {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    white-space: pre-line;
    word-break: break-word;
  }
  .notifications-inbox-modal-body {
    white-space: pre-line;
    word-break: break-word;
    font-size: 0.9rem;
  }
</style>
<style>
  .notifications-inbox-actions-toggle {
    width: 32px;
    height: 32px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
  }
  .notifications-inbox-row-unread {
    box-shadow: inset 3px 0 0 0 #f0ad4e;
    background-color: #fffaf2;
  }
  .notifications-inbox-row-archived {
    box-shadow: inset 3px 0 0 0 #adb5bd;
    color: #adb5bd;
  }
</style>
